import * as React from 'react';
import { FieldRenderProps } from 'react-final-form';
import { Field } from '../form/Field';
import { VFFilterFieldProps } from '../form/types';
import { NumberInput } from '../number/NumberInput';
import { FilterItem } from './FilterItem';
import { FilterFieldProps, getFilterFieldFormValuePath } from './types';
import { DATA_FILTER_INPUT } from '../common/data';

export type NumberProps = VFFilterFieldProps<
  React.ComponentProps<typeof NumberInput> & FilterFieldProps
>;
export const FilterNumber = React.forwardRef<HTMLInputElement, NumberProps>(
  (
    {
      name,
      validate,
      className,
      inputClassName,
      label,
      required,
      disabled,
      size = 6,
      filterType,
      extendedFilter,
      ...other
    },
    ref
  ) => {
    return (
      <FilterItem
        name={name}
        className={className}
        label={label}
        disabled={disabled}
        filterType={filterType}
        extendedFilter={extendedFilter}
      >
        <Field
          name={getFilterFieldFormValuePath(name, filterType)}
          validate={validate}
        >
          {({
            input: { value, onChange, onBlur, name, ...nother },
            meta,
          }: FieldRenderProps<number>) => {
            return (
              <NumberInput
                {...DATA_FILTER_INPUT(name)}
                className={inputClassName}
                size={size}
                // @ts-ignore
                ref={ref}
                {...nother}
                // @ts-ignore
                name={name}
                {...other}
                disabled={disabled || meta.submitting}
                value={value}
                onChange={(newValue: any) => {
                  onChange({ target: { name, value: newValue } });
                }}
              />
            );
          }}
        </Field>
      </FilterItem>
    );
  }
);
